export const ja = {
  locale: 'ja',
  nav: {
    setup: 'コントロールセンター',
    news: 'ニュース',
    brand: 'WC26シミュレーター',
    teamName: 'チーム',
    tactics: '戦術',
    fixtures: '試合日程',
    standings: '順位表',
    knockout: 'トーナメント',
    teamStats: 'チーム統計',
    playerStats: '選手統計',
  },
  landing: {
    title: 'ワールドカップ・シミュレーション',
    subtitle: '開幕戦から決勝戦まで。観客として見学するか、監督としてチームを率いるかを選択してください。',
    audienceMode: {
      title: '観客モード',
      subtitle: 'トーナメント全体を観戦',
      desc: '全試合をステップ実行し、ニュース、順位表、トーナメント表、チーム統計、得点ランキングを追跡します。',
    },
    coachMode: {
      title: '監督モード',
      subtitle: '代表チームを指揮',
      desc: '代表チームを選択して監督席へ。選手層や戦術を確認し、フォーメーション、メンタリティ、プレス、パススタイルを調整します。',
    },
    completed: '試合終了',
    upcoming: '今後の試合',
    championRanking: '優勝予想ランキング',
    coachPickRanking: '監督人気ランキング',
    noCompleted: 'まだ試合はありません。シミュレーション開始後に結果が表示されます。',
    noUpcoming: '',
    noCoachPick: '監督モードでの選択記録はまだありません。',
    coachSetup: {
      title: 'チームを選択し、栄光へ導きましょう',
      back: '戻る',
      start: 'ワールドカップの旅を始める',
      processing: '旅を作成中',
      hiddenTeamsOpen: "隠しチームを表示",
      hiddenTeamsClose: "隠しチームを非表示",
    },
    rosterInfo: 'グループ{group} · {count}名の選手',
    simKicker: {
      audience: '観客モード · 全試合カバレッジ',
      coach: '監督モード · グループ{group}',
    },
    simTitle: {
      audience: 'ワールドカップ・全試合カバレッジセンター',
      coach: '{flag} {name}のワールドカップの旅',
    },
    warning: {
      leave: '現在のシミュレーションデータが失われます。',
      confirm: '現在のシミュレーションデータが失われます。本当に離れますか？',
    },
    groupLabel: 'グループ{id}',
    championCount: '{count}回',
    coachPickCount: '{count}選択',
  },
  common: {
    continue: '続行',
    processing: '処理中',
    completed: '完了',
    close: '閉じる',
    back: '戻る',
    vs: 'VS',
    restart: '新しく開始',
    restartConfirm: '新しく開始しますか？現在の進行状況とローカル保存データは削除されます。',
    playAgain: 'もう一度プレイ',
  },
  team: {
    tab: {
      players: '選手一覧',
      fixtures: '試合日程',
      tactic: '戦術',
    },
    playerTable: {
      player: '選手',
      club: 'クラブ',
      status: '状態',
      position: 'ポジション',
      ability: '能力',
      age: '年齢',
      caps: '代表',
      ntGoals: '代表得点',
      apps: '出場',
      goals: '得点',
      assists: 'アシスト',
      rating: '平均評価',
    },
    status: {
      redCard: 'レッドカード',
    },
    noTactic: 'このチームはまだ試合を完了していません。',
    tactic: {
      formation: 'フォーメーション',
      mentality: 'メンタリティ',
      width: '幅',
      tempo: 'テンポ',
      passing: 'パス',
      attackRoute: '攻撃方向',
      transition: 'トランジション',
      pressing: 'プレス',
      defensiveLine: 'ディフェンスライン',
      possession: 'ポゼッション',
    },
  },
  tactics: {
    formation: 'フォーメーション',
    more: 'さらに表示',
    roster: {
      title: '選手一覧',
      order: '#',
      status: '状態',
      name: '名前',
      position: 'ポジション',
      ability: '能力',
      apps: '出',
      goals: '得',
      assists: '助',
    },
    emptySlot: '空き',
    noData: '戦術データがありません',
    benchPrefix: '控え',
    starterPrefix: '先発',
  },
  stats: {
    team: {
      title: 'チーム統計',
      subtitle: '累積パフォーマンス順',
      noData: 'チームデータはまだありません。',
      ranking: 'チームランキング',
      value: '値',
      matches: '試合',
    },
    player: {
      title: '選手統計',
      subtitle: '選手ランキング',
      noData: '選手データはまだありません。',
      nationality: '国籍',
      value: '値',
      apps: '出場',
    },
    playerTotals: {
      title: 'チーム選手トータル',
      subtitle: '完了した試合のみ。',
      noData: 'あなたのチームはまだ試合をしていません。',
    },
    groups: {
      overall: '総合',
      form: '調子',
      discipline: '規律',
      attack: '攻撃',
      creative: '創造性',
      goalkeeping: 'ゴールキーパー',
    },
    items: {
      avgPossession: '平均ポゼッション',
      goalsFor: '総得点',
      xg: 'xG',
      shots: 'シュート',
      formText: '調子',
      winStreak: '連勝',
      unbeatenStreak: '連続無敗',
      winlessStreak: '連続未勝利',
      scorelessStreak: '連続無得点',
      yellowCards: 'イエローカード',
      redCards: 'レッドカード',
      fouls: 'ファウル',
      goals: '得点',
      assists: 'アシスト',
      minutesPerGoal: '分/得点',
      apps: '出場数',
      starts: '先発',
      averageRating: '平均評価',
      keyPasses: 'キーパス',
      passesAttempted: 'パス',
      passCompletion: 'パス成功率',
      saves: 'セーブ',
    },
    descriptions: {
      avgPossession: '完了試合の平均ポゼッション',
      goalsFor: '総得点',
      xg: '累積xG',
      shots: '総シュート数',
      formText: '最近の調子',
      winStreak: '現在の連勝記録',
      unbeatenStreak: '現在の無敗記録',
      winlessStreak: '現在の未勝利記録',
      scorelessStreak: '連続無得点試合',
      yellowCards: 'イエローカード合計',
      redCards: 'レッドカード合計',
      fouls: 'ファウル合計',
      playerGoals: '得点ランキング',
      playerAssists: 'アシストランキング',
      playerXg: 'xGランキング',
      playerShots: 'シュートランキング',
      minutesPerGoal: '1得点あたりの時間',
      playerApps: '出場数ランキング',
      playerStarts: '45分以上出場試合',
      playerYellowCards: '選手イエローカード',
      playerRedCards: '選手レッドカード',
      playerAvgRating: '平均評価',
      playerKeyPasses: '選手キーパス',
      playerPasses: '総パス試行数',
      playerPassCompletion: 'パス成功率',
      playerSaves: 'セーブランキング',
    },
  },
  position: {
    gk: 'ゴールキーパー',
    def: 'ディフェンダー',
    mid: 'ミッドフィールダー',
    fwd: 'フォワード',
  },
  stage: {
    'Group Stage': 'グループステージ',
    'Round of 32': '1回戦',
    'Round of 16': 'ラウンドオブ16',
    'Quarter-final': '準々決勝',
    'Semi-final': '準決勝',
    'Third Place': '3位決定戦',
    'Final': '決勝',
  },
  match: {
    penaltyMarker: 'PK',
    extraTimeMarker: '延長',
    penalty: {
      scored: '成功',
      missed: '失敗',
    },
    status: {
      finished: '試合終了',
      notStarted: '未開始',
      pending: '未定',
    },
    viewDetail: '詳細を見る',
    modal: {
      teamData: 'チームデータ',
      playerData: '選手データ',
      finalResult: '最終結果',
      restart: 'もう一度プレイ',
      subtitle: {
        extra: '通常時 {normal}、延長 {extra}。',
        penalty: '通常時 {normal}、延長 {extra}、PK {penalty}、{winner} が勝ち抜け。',
      },
    },
    shootout: 'PK戦',
    extraTime: '延長戦',
    decision: {
      penalty: ' · PK {home}-{away}',
      extra: ' · 延長 {home}-{away}',
    },
    news: {
      penalty: '試合は通常時{normal}、延長戦{extra}で終了。{winner}がPK戦{penalty}で勝利。',
      extraTime: '試合は通常時{normal}で終了、延長戦で{goals}得点。最終スコア：{final}。',
    },
    fallback: '{home}と{away}は{stage}で{score}で終了。',
    eventsFallback: '試合は中盤の支配と守備の詳細で決まった。',
    xg: 'xG {home}/{away}',
    possession: 'ポゼッション {home}/{away}',
    shots: 'シュート {home}/{away}',
    best: '最優秀 {player}',
    simulate: 'シミュレート',
    simTitle: 'シミュレーション結果',
    simulating: 'シミュレーション中…',
    simProgress: 'この試合のシミュレーションを10回実行中',
  },
  fixture: {
    title: '試合日程',
    noDate: '試合日なし',
    prevDay: '前の試合日',
    nextDay: '次の試合日',
  },
  knockout: {
    title: 'トーナメント',
    subtitle: '1回戦から決勝への道',
    tabs: {
      bracket: 'トーナメント表',
    },
    stageNotGenerated: 'このステージの日程はまだ生成されていません。',
    tbd: '未定',
  },
  standings: {
    rank: '順位',
    team: 'チーム',
    played: '試合',
    wins: '勝',
    draws: '分',
    losses: '敗',
    goalsFor: '得点',
    goalsAgainst: '失点',
    goalDiff: '得失差',
    points: '勝点',
    filter: 'フィルター',
  },
  tacticsControls: {
    mentality: {
      label: 'メンタリティ',
      options: ['超攻撃的', '攻撃的', '積極的', 'バランス', '慎重', '守備的', '超守備的'],
    },
    width: {
      label: '幅',
      options: ['狭い', 'やや狭い', '標準', 'やや広い', '広い'],
    },
    tempo: {
      label: 'テンポ',
      options: ['遅い', 'やや遅い', '標準', 'やや速い', '速い'],
    },
    passing: {
      label: 'パス',
      options: ['ロングボール', 'ダイレクト', 'ミックス', 'ショート', '非常に短く'],
    },
    attackRoute: {
      label: '攻撃方向',
      options: ['サイド', 'ミックス', '中央'],
    },
    transition: {
      label: 'トランジション',
      options: ['後方からビルドアップ', '守備から組み立て', 'ミックス', '素早く中盤へ', '素早く前線へ'],
    },
    defensiveLine: {
      label: 'ディフェンスライン',
      options: ['低い', '標準', '高い'],
    },
    pressing: {
      label: 'プレス',
      options: ['低い', '標準', '高い'],
    },
    possession: {
      label: 'ポゼッション',
      options: ['引いて守る', 'ポゼッション抑える', 'バランス', 'ポゼッション高める', '完全支配'],
    },
  },
  formations: {
    '4-2-3-1A': '4バック、2アンカー、2ウィンガー、1トップ下、1ストライカー',
    '4-2-3-1S': '4バック、2アンカー、1セントラルMF、2ウィンガー、1ストライカー',
    '4-3-3': '4バック、3ミッドフィルダー、3フォワード',
    '4-1-4-1': '4バック、1アンカー、4フラットMF、1ストライカー',
    '4-1-2-2-1': '4バック、1アンカー、2セントラルMF、2ウィンガー、1ストライカー',
    '4-3-1-2M': '4バック、3セントラルMF、1トップ下、2フォワード',
    '4-3-1-2D': '4バック、3アンカー、1セントラルMF、2フォワード',
    '4-3-2-1M': '4バック、3セントラルMF、2トップ下、1ストライカー',
    '4-3-2-1D': '4バック、3アンカー、2セントラルMF、1ストライカー',
    '4-3-2-1S': '4バック、3セントラルMF、2ウィンガー、1ストライカー',
    '4-4-1-1': '4バック、4フラットMF、1トップ下、1ストライカー',
    '4-2-2-2': '4バック、2アンカー、2ウィンガー、2フォワード',
    '4-4-2F': '4バック、4フラットMF、2フォワード',
    '4-4-2D': '4バック、ダイヤモンドMF、2フォワード',
    '3-3-2-2': '3センターバック、2ウイングバック、1アンカー、2セントラルMF、2フォワード',
    '3-2-4-1': '3センターバック、2アンカー、2ワイド、2セントラルMF、1ストライカー',
    '3-2-2-2-1': '3センターバック、2ウイングバック、2セントラルMF、2ウィンガー、1ストライカー',
    '3-2-3-2D': '3センターバック、2アンカー、2ワイド、1セントラルMF、2フォワード',
    '3-2-3-2W': '3センターバック、2ウイングバック、3セントラルMF、2フォワード',
    '3-4-1-2': '3センターバック、2ウイングバック、2アンカー、1トップ下、2ストライカー',
    '3-4-2-1S': '3センターバック、2ウイングバック、2アンカー、2ウィンガー、1ストライカー',
    '3-4-2-1C': '3センターバック、2ウイングバック、2アンカー、2トップ下、1ストライカー',
    '3-4-3F': '3センターバック、4フラットMF、3フォワード',
    '3-4-3D': '3センターバック、ダイヤモンドMF、3フォワード',
    '5-3-2': '5バック、3セントラルMF、2フォワード',
    '5-4-1F': '5バック、4フラットMF、1ストライカー',
    '5-4-1D': '5バック、ダイヤモンドMF、1ストライカー',
    '5-2-2-1': '5バック、2アンカー、2ウィンガー、1フォワード',
  },
  news: {
    title: 'ニュース',
    subtitle: '試合の最新情報',
    titleTexts: {
      groupRecap: 'グループステージ総括：予選通過チーム、サプライズ、順位表',
      knockoutRecap: '{stage}総括：予選通過チームと重要な転機',
      stagePreview: '{stage}プレビュー：注目カードと予想',
      championRoad: '{flag} {name}の栄光への道',
      awards: 'ワールドカップ表彰：最優秀選手、得点王、最優秀GK',
      review: 'ワールドカップ総評：優勝、番狂わせ、大勝、そしてヒーロー',
      coachSummary: '{team}の大会総括',
    },
    kicker: {
      author: '作者からのメッセージ',
      guide: 'クイックガイド',
      welcome: {
        coach: '監督席へようこそ',
        audience: 'トーナメントセンターへようこそ',
      },
      stageRecap: '振り返り · {stage}',
      stagePreview: 'プレビュー · {stage}',
      champion: '優勝ストーリー',
      awards: '表彰',
      tournamentReview: '大会総評',
      pregame: '試合前',
      coachSummary: '大会総括',
    },
    default: {
      title: 'シミュレーション未開始',
      body: 'モードを選択すると、ニュースが表示され始めます。',
    },
    guide: {
      title: '続行を押すと、まずニュースを読み、その後試合日に進みます',
      body: '{続行}ボタンはページ右上にあります。観客モードでは、未読のニュースが優先表示されます。読み終えると当日の試合日程が表示されます。もう一度{続行}を押すと、その日の試合がシミュレートされます。',
    },
    author: {
      title: '作者からの（大きな）感謝の言葉',
      body: '寝不足でプログラムを書きまくったプログラマーの美的感覚に耐えてクリックしてくれてありがとうございます。シミュレーションが楽しかったら、作者を褒めてください；まさかの結果だったら…それもサッカーの魅力です！フィードバックがあれば、x.com/diysimon または Xiaohongshu（diysimon）までご連絡ください。',
    },
    finalThanks: {
      title: '大会終了 — プレイしていただきありがとうございます！',
      body: '2026年ワールドカップが終了しました。このシミュレーションをお楽しみいただきありがとうございます！作者（X @diysimon / Xiaohongshu diysimon）をフォローして、最新情報、フィードバック、今後のプロジェクトをご確認ください。新しいランを開始して、別の道を試してみてください！',
    },
    coachSummary: {
      intro: '{team}との旅が終わりました。チームは{position}でフィニッシュしました。',
      record: '大会を通じて、{team}は{wins}勝{draws}分{losses}敗、得点{goalsFor}、失点{goalsAgainst}でした。',
      position: '{team}は{position}位でフィニッシュしました。',
      exit: '{stage}で{opponent}に敗れました。',
      exitNone: 'ノックアウトステージを無敗で終えました。',
      topScorer: '得点王：{name}（{goals}得点）。',
      noScorer: '得点ランキングで目立った選手はいませんでした。',
      bestWin: '最大勝利：{match}。',
      meta: '{wins}勝{draws}分{losses}敗 | {goalsFor}得{goalsAgainst}失 | {position}',
      factRecord: '成績：{wins}勝{draws}分{losses}敗',
      factGoals: '得点：{goalsFor}得点 / {goalsAgainst}失点（差{diff}）',
      factTopScorer: '得点王：{name}（{goals}得点）',
      factChampion: '{team}がワールドカップ優勝！',
      factFinish: '最終順位：{position}',
      positions: {
        champion: '優勝',
        runnerUp: '準優勝',
        semiFinal: 'ベスト4',
        quarterFinal: 'ベスト8',
        round16: 'ラウンドオブ16',
        round32: 'ラウンドオブ32',
        groupStage: 'グループステージ',
      },
    },
    welcome: {
      coach: {
        title: '{flag} {name} ワールドカップの旅が始まる',
        body: 'あなたは{name}の指揮を執っています。左メニューからチーム、戦術、試合日程、統計を確認できます。',
      },
      audience: {
        title: '2026 ワールドカップ完全シミュレーションを読み込みました',
        body: '観客としてトーナメントを観戦しています。システムは試合ごとに進行します。',
      },
    },
    facts: {
      thanks: 'プレイしていただきありがとうございます',
      feedback: 'フィードバック歓迎',
      entertainment: '娯楽目的のシミュレーションです',
      newsFirst: '最新ニュースを優先表示',
      fixtureBrowse: '試合日ごとの日程',
      resultsGenerate: '試合結果からニュース生成',
      newsUpdates: 'ニュースはライブ更新',
      timeline: 'タイムラインに今後の試合表示',
      refreshWarning: '更新または離脱でシミュレーションデータ消失',
      operation: '遊び方',
      preMatch: '試合前ブリーフィング',
    },
    narrative: {
      intro: {
        penalty: '{winner}が激戦の{stage}をPK戦{score}で制した。',
        extraTime: '{winner}が延長戦の末{winnerScore}で勝利し、激闘の{stage}を勝ち取った。',
        win: [
          '{winner}が{stage}で試合の主導権を握り、{score}で勝利した。',
          '{winner}が堅実な攻守で相手を上回り、{stage}を{score}で終えた。',
          '{winner}がこの{stage}の重要な局面を捉え、{score}で試合を決めた。',
          '{winner}が{stage}で着実に試合を進め、{score}で勝利を収めた。',
          '{stage}は序盤から緊迫した展開だったが、{winner}の決勝点が{score}の勝利を決めた。',
        ],
        draw: [
          '緊迫した{stage}は{home}と{away}が{score}で引き分けた。',
          '{home}と{away}が{stage}で激しく戦い合ったが、決着はつかず——最終スコア{score}。',
          '{stage}は勝者なきまま終了：{home}と{away}が{score}で分け合った。',
        ],
      },
      noEvent: [
        '両者とも決定的な局面を作り出せなかった。中盤の攻防と敵陣でのブロックが試合を特徴づけた。',
        '両守備陣がしっかりと形を保ち、真の得点機会はほとんど生まれなかった。',
        '決定力が試合のテーマとなった——好機は最後の瞬間にことごとく潰えた。',
      ],
      goal: {
        extraTime: [
          '{minute}、延長戦がクライマックスを迎えた。{scorer}が{assister}のパスに合わせて{method}、スコアは{score}。',
          '{minute}、{team}が延長戦のチャンスを活かした。{scorer}がGKを{method}、{team}が{state}。',
          '{minute}、足が止まりスペースが広がる中、{scorer}が冷静に{method}、スコアは{score}。',
          '{minute}、{scorer}が延長戦の決定的瞬間を演出し、{method}で{team}が再び勢いを取り戻した。',
        ],
        withAssist: [
          '{minute}、{scorer}が{assister}の右サイドからのクロスに合わせ、DFの前で{method}、{team}が{state}。',
          '{minute}、{assister}が鋭いパスを通し、{scorer}がそれに飛びついて{method}、{team}が{state}。',
          '{minute}、{team}が鮮やかな連係を見せた。{assister}が{scorer}に落とし、{scorer}が{method}、スコアは{score}。',
          '{minute}、{scorer}が{assister}のクロスを活かし、無防備なGKを{method}、{team}が{state}。',
          '{minute}、{assister}が相手のラインを破るパスを送り、{scorer}がそのまま{method}——{score}。',
          '{minute}、{team}が前線でボールを奪い素早く展開。{assister}が{scorer}に横パスを送り、{scorer}が{method}。',
          '{minute}、{assister}がセットプレーを危険なエリアに蹴り込んだ。{scorer}が防御網を{method}、{team}が{state}。',
          '{minute}、{scorer}が{assister}の折り返しに合わせてファーストタッチで{method}——攻撃が{score}を作り出した。',
          '{minute}、{assister}がDFを引きつけてからパスを送った。{scorer}がスペースを見つけて{method}、{team}が{state}。',
          '{minute}、{team}が隙ができるまで辛抱強くボールを動かした。{assister}がラストパスを送り、{scorer}が{method}。',
        ],
        solo: [
          '{minute}、{scorer}がペナルティエリア手前でDFを振り切って{method}、{team}が{state}——{score}。',
          '{minute}、{scorer}がクリアミスに反応し、無人のゴールに{method}。',
          '{minute}、{scorer}が中盤からエリア手前までドリブルで持ち込み、{method}。',
          '{minute}、{team}のハイプレスが混乱を引き起こした。{scorer}が素早く反応して{method}、スコアは{score}。',
          '{minute}、{scorer}が混戦の中で一番早く反応し、至近距離から{method}、{team}が{state}。',
        ],
        methodHigh: ['ヘディングで合わせた', '押し込んだ', 'ループで決めた', '近距離からねじ込んだ'],
        methodLow: ['ミドルシュートを突き刺した', 'カーブで巻いた', '遠距離から狙いすました', 'ボレーで叩き込んだ'],
        methodMid: ['打ち抜いた', '流し込んだ', '叩き込んだ', '冷静に決めた', '角度をつけて決めた'],
      },
      chance: [
        '{minute}、{team}がもう少しで{chanceState}ところだった。{player}がGKと1対1になったが、相手GKが勝った。',
        '{minute}、{player}にボックス内で絶好のチャンスが訪れたが、最後の瞬間に枠を外した。',
        '{minute}、{team}がカウンターから素早く攻め込んだが、{player}のシュートはポストの横をかすめた。',
        '{minute}、{player}がクロスに合わせて良い走り込みを見せたが、枠を捉えられなかった。',
      ],
      redCard: [
        '{minute}、{team}に痛手。{player}がレッドカードを受け、試合の流れが変わった。',
        '{minute}、{player}が退場処分に。{team}は残り時間を守備的に戦わざるを得なくなった。',
        '{minute}、審判が{player}にレッドカードを提示。{team}の試合計画が即座に変更を余儀なくされた。',
      ],
      flow: {
        xgGap: '{dominant}がより良いチャンスを作り出し、xG{xgHome}-{xgAway}、シュート数{shotsHome}-{shotsAway}とリードした。',
        possession: '{controller}がポゼッション{possession}%でボールを支配したが、ボックス内での効率性がより重要だった。',
        balanced: 'チャンスの質の差はわずかで（xG{xgHome}-{xgAway}）、試合はトランジションと決定力で決した。',
      },
      tactic: {
        control: [
          '戦術的に、{controller}がテンポを支配し、忍耐強いパス回しでボールを動かし続け、ポゼッション{possession}%を記録した。',
          '{controller}の計画は明確だった：ボールを保持し、サイドとハーフスペースから攻略し、相手にリズムを築かせないこと。',
          '{controller}は持続的なポゼッションで相手のプレスを弱め、試合を自分たちのペースで進めた。',
          '{controller}はコンパクトな陣形を保ちながら辛抱強くボールを保持し、敵陣で過ごす時間を増やした。',
        ],
        direct: [
          '{direct}はポゼッションを追い求めなかった——ボールを素早くボックスに入れることを優先し、より多くのシュートがその姿勢を反映した。',
          '攻撃面では、{creator}が危険なエリアを見つけるのに優れており、キーパス数で優位に立って守備陣に圧力をかけ続けた。',
          '{direct}は意図を持ってボールを動かし、中盤の混雑を回避してゴールへと直進した。',
          '{creator}は敵陣で多彩な攻撃を見せた——クロス、スルーパス、セカンドボールの争いがすべて脅威を生み出した。',
        ],
        pressure: [
          '{presser}がオフザボールで大きく貢献し、相手がファーストパスをクリーンに出せないようにした。',
          '{presser}の守備規律が際立った——MFが素早く戻り、危険がボックスに到達する前に排除した。',
          'フィジカルな強度が高かった。{presser}が容赦ないプレスとカバーランで供給ルートを断った。',
          '{presser}はボールを失った後の奪還に積極的だった——必ずしもシュートには結びつかなかったが、カウンターアタックを封じた。',
        ],
        balanced: [
          '両者とも慎重な実行を心がけ、コンパクトな陣形を保ち、デュエルとセカンドボールで勝負が決まる展開に委ねた。',
          'オープンな展開ではなかった。どちらも守備構造を放棄せず、わずかなキーパスに頼って突破を試みた。',
          '両チームがリスクを慎重に管理し、前掛かりになるのを制限した。試合は一握りの高品質な瞬間によって形作られた。',
          '戦術的には、両者が互いを打ち消し合った：一方が加速しようとし、他方が中央のスペースを塞いだ。',
          '中盤での攻防がリズムを繰り返し断ち切り、両者とも守備的トランジションを優先したことが示された。',
        ],
      },
      coach: {
        late: [
          'コーチ陣の忍耐が報われた。{winner}は後半に焦らず、相手が疲れるのを待ってから決定的な一撃を加えた。',
          '{winner}の交代と布陣が連動し、後半に持続的な圧力をかけられた——優れた試合運びの証だ。',
          '{winner}は膠着状態でも陣形を維持した。終盤のゴールは焦りではなく持続的な圧力の自然な結果だった。',
          '{winner}のスタッフは終盤に攻め続けることを選択し、その決断が試合を決める瞬間を勝ち取った。',
        ],
        red: [
          'レッドカード後、{redTeam}のスタッフは陣形を調整し、コンパクトなブロックと素早い出口で試合に留まった。',
          '{opponent}は人数有利を活かして展開を広げようとしたが、{redTeam}のコンパクトな対応が試合を壊れにくくした。',
          '1人少ない状況は{redTeam}の適応力を試した。彼らは中盤でのリスクのあるパスを減らし、守備の堅固さを優先した。',
          '{opponent}のスタッフはレッドカード後により速いボール回しを指示し、数的優位をサイドでのオーバーロードに活かそうとした。',
        ],
        narrow: [
          '{winner}のスタッフは現実的な判断を下した——リードを奪った後、追加点を追わず、確固たるポジショニングでアドバンテージを守った。',
          '{winner}は得点後にコントロールを優先し、不必要なリスクを減らして試合を管理しやすい状態に保った。',
          '{winner}は派手さなく勝利した。スタッフのリスク管理は的確で、相手に反撃の機会をほとんど与えなかった。',
          '勝利は{winner}の現実的な姿勢を反映していた：まず守備を固め、前線の選手に試合を決めさせる。',
        ],
        win: [
          '{winner}は試合計画を効果的に実行し、リードを奪った後も攻撃構造を維持した。',
          '{winner}はトランジションでインテリジェントにポジショニングした。スタッフは明らかにボール喪失後の即時プレスを要求していた。',
          '{winner}の勝利は個人の質だけではなかった——陣形とセカンドボールの保護がスコアラインを支えた。',
          '{winner}は成熟した試合運びを見せ、いつ押し込むべきか、いつボールを保持すべきかを理解していた。',
        ],
        draw: [
          'どちらのコーチ陣も引き分けで完全なリスクを冒さなかった。終盤の交代とポジショニングは敗北を避ける方向に傾いた。',
          '両者とも幅を活かしてチャンスを作ろうとしたが、中央の守備は最後まで破られることはなかった。',
          '引き分けは両監督の慎重さを反映していた：攻撃の意図はあったが、どちらも完全に前掛かりにはならなかった。',
          '両チームとも終盤に中盤の守備を強化し、カウンターアタックで試合を決められることへの警戒を強めた。',
        ],
      },
      player: {
        goals: [
          '{player}が際立った存在であり、複数のフィニッシュで試合を変え、評価{rating}を記録した。',
          '{player}の決定力が試合を決めた——その動き出しは常に最も守りにくいスペースを突いていた。',
          '{team}の攻撃は{player}が仕上げた。冷静なシュートで相手守備陣に継続的なプレッシャーをかけた。',
          '{player}が流れを変える存在となり、チャンスを実際のスコアボードへのプレッシャーに変えた。',
        ],
        attack: [
          '{player}が重要な場面で影響力を発揮した。ゴールやアシスト以上に、リンクアッププレーで{team}を前進させた。',
          '{player}の貢献はスタッツシート以上のものだった——攻撃の要となるべき場所に常に出現した。',
          '{player}がこの試合で自らの役割を全うし、{team}の攻撃の焦点となる重要な決断を下した。',
          '{player}は敵陣で決断力を発揮した——いつパスを出し、いつシュートを打つべきかを知っており、{team}の頼れる軸となった。',
          '{player}の動きがスペースを作り出し、直接的な関与が試合の勢いを変えた。',
        ],
        saves: [
          '{player}のゴールでの働きは不可欠だった。複数のセーブで{team}を試合に留めた。',
          'GK {player}は特筆に値する。次々とセーブを決めて相手の攻撃を阻んだ。',
          '{team}は{player}の反射神経のおかげでプレッシャーに耐えた——シュートストッピングが重要な要素だった。',
          '{player}にミスの余地はほとんどなかったが、至近距離からのシュートに対しても冷静に対応し、すべてクリーンに処理した。',
        ],
        create: [
          '{player}は{team}の敵陣で最も重要なリンクとなり、キーパスでチームメイトにシュート機会を創出した。',
          '{player}の視野が{team}の攻撃パターンを形作った——混雑したエリアでも常にパスコースを見つけた。',
          '{team}にはボールを危険なゾーンに届ける選手が必要だったが、{player}がその役割を完璧に果たした。',
          '{player}はゴールだけを追い求めなかった——パスを使ってチームメイトをより良いシュート位置に置いた。',
        ],
        defense: [
          '{player}が守備面で広大な範囲をカバーし、タックルとインターセプトで{team}の中盤の盾を強化した。',
          '{team}は{player}の戻り守備と予測のおかげで相手の前進を制限した。',
          '{player}の価値はオフザボールにあり、相手のパスの組み立てが発展する前に繰り返し遮断した。',
          '{player}の守備作業は評価に値する。ボックス周辺の危険な場面から{team}を何度も救った。',
        ],
        shots: [
          '{player}はチャンスをゴールに結びつけられなかったが、常にシュートを打ち続けて相手守備陣を警戒させた。',
          '{team}の攻撃の多くは{player}から生まれ、シュートで突破口を開こうと試み続けた。',
          '{player}の積極性が際立った——複数のシュートは敵陣で常にスペースを見つけていたことを示している。',
          '{player}はゴールまであと一歩だった——そのシュートはすでに相手GKを最高度の警戒状態に追い込んでいた。',
        ],
        general: [
          '{player}が最高評価の一つを獲得し、{team}の攻守両面で安定したプレーを提供した。',
          '{player}の数字はすべてを物語っているわけではない——その関与は{team}のリズム維持に不可欠だった。',
          '{player}のオールラウンドなパフォーマンスが最も評価され、複数の状況で適切な判断を下した。',
          '{player}の価値は信頼性にあった——ポゼッションを無駄にせず、常に守備作業に参加した。',
        ],
      },
      impact: {
        finalWin: '{winner}が決勝を制し、ワールドカップトロフィーを掲げた。{loser}の旅はあと一歩で終わった。',
        thirdPlace: '{winner}がワールドカップ3位、{loser}が4位となった。',
        semiFinal: '{winner}がこの勝利で決勝に進出し、{loser}のトロフィー獲得の望みは絶たれた。',
        quarterFinal: '{winner}が準決勝に進出。あと1勝で決勝だ。',
        knockoutWin: '{winner}がノックアウトステージを勝ち進む一方、{loser}は敗退した。',
        placementBothDark: '両チームともトーナメント前のオッズを大きく上回った——3位決定戦自体が番狂わせの物語だった。',
        placementThirdDark: '{thirdName}がトーナメント前オッズトップ20外から表彰台に上がり、すべての期待を超えた。',
        placementFourthDark: '{fourthName}はこの試合に敗れたが、準決勝に進出した時点ですでに事前の期待を超えていた。',
        placementBothFavored: '両チームともトーナメント前オッズでトップ20に入っており、ベスト4進出はほぼ予想通りの結果だ。',
        groupLead: '{teamName}はグループ{played}試合で{points}ポイント、グループ内{rank}位と、予選突破に向けて好位置につけている。',
        groupEliminated: '{teamName}は{played}試合で{points}ポイントのみ、グループ内{rank}位で、突破は不可能となった。',
        groupUpdate: 'この試合の後、{teamName}は{points}ポイント、グループ{group}で{rank}位。',
        groupQualifiers: 'グループ{groupId}：{names}',
        qualified: '予選通過',
        eliminated: '敗退',
        favoriteStatus: '{name} {status}',
        darkHorses: '{names}がこのステージの最も注目すべきダークホースで、勝ち点、得失点差、または重要な試合で期待を上回った。',
        noDarkHorses: '総じて本命チームが地歩を固めた——グループ順位に大きな変動は見られなかった。',
        unbeaten: '{names}が無敗を維持し、印象的な安定感を示している。',
        scorers: '個人成績では、{scorerLine}。{assisterLine}。{ratingLine}',
        scorerLead: '{name}が{goals}得点で得点ランキングをリード',
        scorerDisperse: '得点王レースは依然として混戦',
        assisterLead: '{name}が{assists}アシストでアシストランキングをリード',
        assisterDisperse: 'アシスト表は依然として接戦',
        ratingHighlight: ' {name}が平均評価{rating}——グループステージの最も傑出した選手の一人。',
      },
      recap: {
        groupIntro: [
          'グループステージが終了した。32チームが勝ち進み、ワールドカップはノックアウトモードに突入する。',
          '72のグループ試合が終了した。予選通過チーム、サプライズ、個人ランキングがすべて形作られた。',
          'グループステージ終了。上位チームの安定感、番狂わせ、得点王レースがこのフェーズを特徴づけた。',
        ],
        knockoutIntro: '{stage}が終了した。{count}チームが優勝争いに残っている。',
        knockoutWinners: '{names}が次ラウンドへの切符を手にした。',
        knockoutTight: '{count}試合が1点差またはPK戦で決着——ノックアウトステージの緊張が高まっている。',
        knockoutClear: 'このラウンドの結果は比較的明快で、勝者がより大きなコントロールを示した。',
        knockoutBiggest: 'このラウンドの最もオープンな試合は{match}で、合計{goals}ゴールが生まれた。',
        knockoutUpset: '番狂わせは{winner}が{loser}を破ったこと——下位ランクのチームがより効率的なパフォーマンスを見せた。',
        knockoutScorers: '個人成績では、{scorerLine}。{ratingLine}',
        knockoutScorerLead: '{name}が{goals}得点で得点ランキングをリードし続けている',
        knockoutScorerDisperse: '得点王レースは依然として混戦',
        knockoutRating: '{name}が高い評価を維持し、ノックアウトステージで最も安定したスターの一人。',
        knockoutRatingGeneric: 'キープレイヤーの調子が優勝レースを形作り始めている。',
        groupLines: 'グループ別予選通過チーム：{lines}。{favorites}',
        groupFavorites: '本命チームの中で、{status}。',
        groupQualifierFormat: 'グループ{groupId}：{names}',
        groupMeta: '{count}チーム予選通過 · {scorerInfo}',
        scorerInfo: '得点王 {name}',
        scorerInfoUpdate: '統計更新',
        factQualified: '{count}チーム予選通過',
        factDarkHorses: 'ダークホース {names}',
        factStable: '本命安定',
        factTopScorer: '得点王 {name} {goals}G',
        factTopAssister: 'アシスト王 {name} {assists}A',
        knockoutMeta: '{count}チーム進出 · {tight}が接戦',
        factKnockoutTight: '{count}試合が接戦',
        factKnockoutClear: '明確な結果',
        factUpset: '番狂わせ {winner}',
        factOpen: '{goals}ゴール',
      },
      preview: {
        intro: '{stage}の組み合わせが決定した。次のフェーズでは{count}試合でさらに絞り込まれる。',
        keyMatch: '注目の対戦カード：{matches}。',
        noKeyMatch: 'このステージではトップ20オッズのチーム同士の直接対決はない——本命は有利に見えるカードでの油断を避けなければならない。',
        favorites: '調子と戦力に基づけば、{names}が勝ち進むと予想される。',
        noFavorites: 'このラウンドの差はわずか——調子と決定力が評判よりも重要になるかもしれない。',
        tail: [
          'ノックアウトステージでは、試合運び、セットプレーの守備、GKの調子が重要になる。一つのミスがトーナメント全体を変えうる。',
          'このフェーズは攻撃力だけが全てではない。交代のタイミング、リスク管理、PK戦の準備が結果に影響する。',
          '本命はスロースタートを避けるべきで、番狂わせを狙う側は試合を自分たちのペースに持ち込みたい。最初の30分が試合のトーンを決める。',
        ],
        previewMeta: '{count}試合',
        factMatchup: '{count}カード',
        factFocus: '注目 {matchup}',
        factFavorite: '本命 {name}',
      },
      champion: {
        road: '{champion}の栄光への道のりが完結：{count}試合、{wins}勝{draws}分、{goalsFor}得点、{goalsAgainst}失点。',
        groupPath: 'グループステージでは、{champion}が早期に予選突破を決めた：{matches}。',
        knockoutPath: 'ノックアウトラウンドでは、{opponents}を打ち破った。',
        signatureMatch: '{match}が彼らのキャンペーンを象徴するパフォーマンスだった。',
        meta: '{wins}勝{draws}分 · {goalsFor}-{goalsAgainst}',
        drawsText: '{draws}分',
        fact: '優勝 {champion}',
        factGoal: '得点 {goalsFor}',
        factConcede: '失点 {goalsAgainst}',
        factSignature: '代表試合 {match}',
        tail: [
          'この優勝チームの特徴は安定性だった：リード時の試合運び、ビハインドや膠着状態での新たな攻撃手段の発見。',
          '彼らのタイトルは単一の閃きによるものではなかった——守備の堅固さ、キープレイヤーの安定した貢献、そして鋭いマネジメントから生まれた。',
          '優勝チームを際立たせたのは、一つの悪い結果に崩されることなく、すべてのノックアウトラウンドを冷静に乗り切ったことだ。',
        ],
      },
      awards: {
        intro: '決勝戦が終了し、ワールドカップの個人賞が決定した。{bestPlayer}',
        bestPlayer: '{name}が一貫した高評価と重要なパフォーマンスで最優秀選手賞を獲得した。',
        noBestPlayer: '最優秀選手賞の争いは極めて接戦で、複数のスターがワールドクラスのパフォーマンスを見せた。',
        topScorer: 'ゴールデンブーツは{goals}得点の{name}に——トーナメントで最も信頼できるフィニッシャー。',
        noTopScorer: '得点ランキングに独走するリーダーはいなかったが、それでも多くの試合でFWの決定力が結果を分けた。',
        topAssister: 'アシストでは{name}が{assists}でトップに——そのパスが複数の試合を直接変えた。',
        bestKeeper: '最優秀GKは{name}、{saves}セーブ、平均失点{conceded}を記録。',
        noBestKeeper: 'GK賞の争いは、ノックアウトステージで安定したパフォーマンスを見せた数名の選手に集中していた。',
        scorerFallback: '得点ランキングリーダー',
        keeperFallback: 'トップGK候補',
        summary: '{names}がこのトーナメントの個人ストーリーを形作った——一人が創り、一人が決め、一人が守った。',
        noSummary: '個人パフォーマンスはチームシステムに強く結びついており、個人の質と同様に戦術的枠組みによって形作られていた。',
      },
      review: {
        intro: 'トーナメントが終了した。全{total}試合で{goals}ゴール、1試合平均{average}。',
        scoring: '{highScoring}試合が4得点以上、{btts}試合で両チーム得点。{biggest}',
        biggest: '最もオープンな試合は{match}。',
        upsetSep: 'が',
        assisterFallback: '複数の創造者',
        ratingFallback: 'キープレーヤー',
        upsets: '番狂わせの記憶には{upsets}。',
        noUpsets: '大半では本命が序列通りの強さを見せたが、ノックアウトラウンドはしばしば僅差で決した。',
        champion: '最終的に{champion}が最も長く集中力を維持し、トーナメントの象徴的なストーリーとなった。',
        leaders: '個人成績では、{scorer}の決定力、{creators}の創造性、{ratings}の高評価がトーナメントの統計的支柱を形成した。',
        noLeaders: 'このトーナメントには支配と驚きの両方があった——実際の物語は単一のスタッツラインよりも豊かだった。',
        awardsMeta: '最優秀選手 {name}',
        awardsMetaDefault: '表彰概要',
        factBestPlayer: '最優秀選手 {name}',
        factTopScorer: '得点王 {name} {goals}G',
        factBestKeeper: '最優秀GK {name}',
        factTopAssister: 'アシスト王 {name} {assists}A',
        reviewMeta: '{count}試合 · {goals}ゴール',
        factTotalGoals: '総得点 {goals}',
        factAvgGoals: '平均{average}',
        factHighScoring: '{count}試合が4得点以上',
        factBothScored: '{count}試合で両者得点',
      },
    },
  },
  helpers: {
    formText: { W: '勝', D: '分', L: '敗' },
    goalState: {
      equalize: '同点に追いつく',
      lead: 'リードを奪う',
      extend: 'リードを広げる',
      chase: '1点を返す',
    },
    chanceState: {
      extend: 'リードを広げる',
      break: '均衡を破る',
      face: '面目を保つ',
      close: '差を縮める',
    },
    tacticSummary: 'メンタリティ {mentality} · 攻撃 {focus} · プレス {pressing} · ライン {line}',
    teamMate: 'チームメイト',
    attacker: '攻撃選手',
    defender: '守備選手',
    advance: 'が勝ち上がり',
    groupLeader: 'グループ{group}首位 {teamName} {points}点',
    unknownPlayer: '不明な選手',
    unsolved: 'N/A',
    minute: '{minute}\'{stoppage}',
    stoppageTime: '+{minute}',
  },
  rendering: {
    playerTotals: {
      headers: ['選手', '位置', '出', '分', '得', '助', 'xG', 'シ', '枠', 'パ', '成', 'KP', 'タ', 'イン', 'YC', 'RC', 'セ', '評価'],
    },
    matchStats: {
      shotsOnTarget: '枠内シュート',
      passes: 'パス',
      passSuccess: 'パス成功率',
      keyPasses: 'キーパス',
      corners: 'コーナーキック',
      offsides: 'オフサイド',
      fouls: 'ファウル',
      yellowCards: 'イエローカード',
      redCards: 'レッドカード',
      saves: 'セーブ',
      tackles: 'タックル',
      interceptions: 'インターセプト',
    },
    modal: {
      best: '最優秀',
      record: '成績',
      stage: 'ステージ',
      bestPlayer: '最優秀選手',
      signature: '代表試合',
    },
    bracket: {
      pending: '未定',
    },
  },
  mobile: {
    landing: { intro: '2026ワールドカップシミュレーター', description: '開幕戦から決勝の夜まで、「続ける」をタップして2026ワールドカップのシミュレーションを見届けましょう。', welcome: 'あなただけのワールドカップ時間へようこそ。タップで素早くシミュレーションし、誰がトロフィーを掲げるか見届けましょう。PCでは監督モードも楽しめます。', hiddenStart: '隠しチームも含めてシミュレート', start: 'シミュレーション開始', startTitle: '今すぐシミュレーション開始', startSubtitle: '実在チームと実際の組み合わせで、10分以内に全試合を観客目線でシミュレートします。', hiddenCheckbox: 'イタリア、ポーランド、インドネシア、中国、UAEをワールドカップに参加させる' },
    topbar: { settings: '設定' },
    tabs: { navigation: 'モバイルナビゲーション', news: 'ニュース', fixtures: '日程', standings: '順位表', knockout: '決勝T', data: 'データ' },
    action: { continue: '続ける', readNews: 'ニュースを読む', simulateNext: '次の試合日をシミュレート', restart: '最初から', completed: '完了' },
    settings: { title: '設定', language: '言語', restart: '最初から', restartConfirm: '現在のモバイルシミュレーションを消去して最初から始めますか？', close: '設定を閉じる' },
    news: { previous: '前へ', next: '次へ', pcMore: 'PC版ではさらに多くの驚きと機能を体験できます。', empty: 'ニュースはまだありません。' },
    fixtures: { previousDay: '前の試合日', nextDay: '次の試合日', noMatches: 'この試合日の予定はありません。' },
    standings: { groupStandings: 'グループ順位', knockout: '決勝トーナメント', roundOf32: 'ラウンド32', roundOf16: 'ラウンド16', quarterFinal: '準々決勝', semiFinal: '準決勝', thirdPlace: '3位決定戦', final: '決勝' },
    data: { goals: '得点', assists: 'アシスト', pcMore: 'PC版ではさらに多くの選手・チームデータを確認できます。', empty: 'データはまだありません。' },
    team: { squad: 'チームリスト', fixtures: '日程', tactic: '戦術', close: 'チーム表示を閉じる' },
  },
    teamNames: {

    mexico: 'メキシコ', south_africa: '南アフリカ', south_korea: '韓国',
    czechia: 'チェコ', canada: 'カナダ', bosnia_herzegovina: 'ボスニア・ヘルツェゴビナ',
    switzerland: 'スイス', qatar: 'カタール', brazil: 'ブラジル', morocco: 'モロッコ',
    scotland: 'スコットランド', haiti: 'ハイチ', united_states: 'アメリカ合衆国',
    australia: 'オーストラリア', paraguay: 'パラグアイ', turkiye: 'トルコ',
    germany: 'ドイツ', curacao: 'キュラソー', ivory_coast: 'コートジボワール',
    ecuador: 'エクアドル', netherlands: 'オランダ', japan: '日本',
    tunisia: 'チュニジア', sweden: 'スウェーデン', belgium: 'ベルギー', iran: 'イラン',
    egypt: 'エジプト', new_zealand: 'ニュージーランド', spain: 'スペイン',
    uruguay: 'ウルグアイ', saudi_arabia: 'サウジアラビア', cape_verde: 'カーボベルデ',
    france: 'フランス', senegal: 'セネガル', norway: 'ノルウェー', iraq: 'イラク',
    argentina: 'アルゼンチン', austria: 'オーストリア', algeria: 'アルジェリア',
    jordan: 'ヨルダン', portugal: 'ポルトガル', colombia: 'コロンビア',
    uzbekistan: 'ウズベキスタン', dr_congo: 'コンゴ民主共和国', england: 'イングランド',
    croatia: 'クロアチア', panama: 'パナマ', ghana: 'ガーナ',
    italy: 'イタリア',
    tbd: '未定',
    china: '中国',

    indonesia: "インドネシア",
    united_arab_emirates: "アラブ首長国連邦",
    poland: "ポーランド",

  },
};
